import { render } from "./B2bFiltersGenralsReceived.vue?vue&type=template&id=65158048&scoped=true&lang=pug"
import script from "./B2bFiltersGenralsReceived.vue?vue&type=script&lang=js"
export * from "./B2bFiltersGenralsReceived.vue?vue&type=script&lang=js"

import "./B2bFiltersGenralsReceived.vue?vue&type=style&index=0&id=65158048&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65158048"]])

export default __exports__